import moment from 'moment'
import React from 'react'

export function getDayOfWeek(obj: moment.Moment) {
  let day = ''
  const wd = obj.day()
  if (wd === 0) day = 'Sunday'
  else if (wd === 1) day = 'Monday'
  else if (wd === 2) day = 'Tuesday'
  else if (wd === 3) day = 'Wednesday'
  else if (wd === 4) day = 'Thursday'
  else if (wd === 5) day = 'Friday'
  else if (wd === 6) day = 'Saturday'

  if (moment().format('MM-DD-YYYY') === obj.format('MM-DD-YYYY')) day = 'Today'
  else if (moment().add(1, 'days').format('MM-DD-YYYY') === obj.format('MM-DD-YYYY'))
    day = 'Tomorrow'

  return day
}

export const getGCD = (arr: number[]) => {
  if (arr.length === 0) return 0
  const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b))
  return arr.reduce((a, b) => gcd(a, b))
}

export const capitalize = (str: string): string => {
  if (str.length === 0) {
    return str
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function makeWhatsappURL(activity: string, city: string) {
  const baseUrl = 'https://wa.me/447472016999'
  const messageParts = [
    'Hello! I would like to book',
    activity || 'a watersport activity',
    city !== 'your location' ? `in ${city}.` : '.',
  ]

  const message = messageParts.filter(Boolean).join(' ')
  return `${baseUrl}?text=${encodeURIComponent(message)}`
}

export const calculateDuration = (
  min_duration?: { value: number; unit: string },
  max_duration?: { value: number; unit: string },
) => {
  if (min_duration && max_duration) {
    if (min_duration.unit === max_duration.unit) {
      return `${min_duration.value} to ${max_duration.value} ${min_duration.unit}`
    }
    return `${min_duration.value} ${min_duration.unit} to ${max_duration.value} ${max_duration.unit}`
  }
  const d = min_duration ?? max_duration
  if (d) {
    return `${d.value} ${d.unit}`
  }
  return undefined
}
export const highlightMatch = (text: string, query: string): React.ReactNode => {
  if (!query) return text

  const parts = text.split(new RegExp(`(${query})`, 'gi'))
  return React.createElement(
    React.Fragment,
    null,
    parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase()
        ? React.createElement('span', { key: index, className: 'underline' }, part)
        : part,
    ),
  )
}
